module.exports = __webpack_public_path__ + "media/get-started/Product-956b5041.png";